/** Small UI store: toasts and which chrome panel is open. */
import { create } from 'zustand';

export interface Toast { id: number; text: string; kind: 'info' | 'error'; }
export type Panel = 'none' | 'drones' | 'tune';

interface UiState {
  toasts: Toast[];
  panel: Panel;
  toast(text: string, kind?: Toast['kind'], ms?: number): void;
  dismiss(id: number): void;
  setPanel(p: Panel): void;
  togglePanel(p: Exclude<Panel, 'none'>): void;
}

let seq = 1;
export const useUi = create<UiState>((set, getState) => ({
  toasts: [],
  panel: 'none',
  toast(text, kind = 'info', ms = 2400) {
    const id = seq++;
    set({ toasts: [...getState().toasts.slice(-2), { id, text, kind }] });
    setTimeout(() => getState().dismiss(id), ms);
  },
  dismiss(id) { set({ toasts: getState().toasts.filter((t) => t.id !== id) }); },
  setPanel(p) { set({ panel: p }); },
  togglePanel(p) { set({ panel: getState().panel === p ? 'none' : p }); },
}));

export const toast = (text: string, kind: Toast['kind'] = 'info') => useUi.getState().toast(text, kind);
